import React from "react";
import Product from "../components/Product";

const HomePage = () => (
  <div className="container">
    <Product />
  </div>
);

export default HomePage;
